import { CRM } from "@/components/atomic-crm/root/CRM";

const App = () => <CRM title="EGI Sales" disableTelemetry />;

export default App;
